import React from "react";
import { RiNotification3Line, RiSearchLine } from "react-icons/ri";
import { useLocation } from "react-router-dom";
import { photo } from "../../assets/imagesPath";
import pageTitles from "./pageTitles"; 

const Header = () => {
  const location = useLocation();
  const heading = pageTitles[location.pathname] || "Overview";

  return (
    <div className="flex justify-between items-center p-4 bg-white shadow-sm">
      <h1 className="font-nunito text-2xl leading-none text-[#173363]">
        {heading.includes("Dashboard") ? (
          heading.split(" ").map((word) => (
            <span
              key={word}
              className={word === "Dashboard" ? "font-bold" : "font-medium"}
            >
              {word}{" "}
            </span>
          ))
        ) : (
          <span className="font-bold  text-2xl leading-none">
            {heading}
          </span>
        )}
      </h1>

      <div className="flex items-center space-x-4">
        <div className="relative">
          <RiSearchLine className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search..."
            className="pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:border-primary"
          />
        </div>

        <div className="relative">
          <RiNotification3Line className="text-2xl text-gray-600 cursor-pointer" />
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
            3
          </span>
        </div>

        <img src={photo} alt="Profile" className="w-10 h-10 rounded-full" />
      </div>
    </div>
  );
};

export default Header;
